__turbopack_context__.v({
  "container": "_1JOzHW_container",
});
